module.exports = __webpack_public_path__ + "img/takeingPhoto.16933a57.png";